import * as React from 'react'
import clx from 'classnames'
import { LoaderIcon } from '@/app/features/icons/Loader'


type Props = {
  text?: string
  className?: string
  children?: React.ReactNode
  isLoading?: boolean
}
export const LoadingScreen = ({
  text,
  className,
  children,
  isLoading = true,
}: Props) => {
  return (
    <div
      className={clx(
        'tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-4',
        className,
      )}
    >
      <LoaderIcon
        className={clx('tw-w-16 tw-animate-spin', {
          'tw-hidden': !isLoading,
        })}
      />
      {text && (
        <span className={clx('tw-text-base', { 'tw-hidden': !isLoading })}>
          {text}
        </span>
      )}
      {children}
    </div>
  )
}
